import {
  UserNotificationListRequest,
  UserNotificationListResponse,
  UserNotificationMarkAsReadRequest,
} from './userNotification.types';
import api from '@/api';

const BASE = '/communication/v1/userNotification';

export default {
  async markAsRead(payload: UserNotificationMarkAsReadRequest) {
    const res = await api.post(`${BASE}/mark-as-read`, payload);
    return res;
  },

  async markAllAsRead() {
    const res = await api.post(`${BASE}/mark-all-as-read`, {});
    return res;
  },

  async listFilter(params: UserNotificationListRequest) {
    const res = (await api.get(`${BASE}/filter`, params)) as unknown;
    return res as UserNotificationListResponse;
  },

  async markAsDismissed(notificationId: number) {
    const res = await api.post(
      `${BASE}/${notificationId}/mark-as-dismissed`,
      {},
    );
    return res;
  },
};
